module.exports = __webpack_public_path__ + "static/media/Singed_0.73d50f32.jpg";